let nameMap = {
  推广目标: "Objective",
  应用名称: "AppName",
  创建日期: "CreateDate",
  计划日预算: "DailyBudget",
  投放方式: "DeliveryType",
  版位: "Placement",
  人群: "Audience",
  用户名: "UserName",
  创意组: "CreativeGroup",
  落地页: "LandingPage",
  定向包: "Targeting",
  自动拓量: "TargetingExpansion",
  开始时间: "BeginTime",
  计费方式: "BidMode",
  出价策略: "BidStrategy",
  优化目标: "Conversion",
  深度优化: "DeepOptimizationGoal",
  目标出价: "BidAmount",
  广告日预算: "BidDailyBudget",
  首个视频名称: "FirstVideoName",
  首个图片名称: "FirstImageName",
  视频名称: "VideoName",
  图片名称: "ImageName",
  创意样式: "CreativeFormat",
};
let apiMap = {
  Objective: "推广目标",
  AppName: "应用名称",
  CreateDate: "创建日期",
  DailyBudget: "计划日预算",
  DeliveryType: "投放方式",
  Placement: "版位",
  Audience: "人群",
  UserName: "用户名",
  CreativeGroup: "创意组",
  LandingPage: "落地页",
  Targeting: "定向包",
  TargetingExpansion: "自动拓量",
  BeginTime: "开始时间",
  BidMode: "计费方式",
  BidStrategy: "出价策略",
  Conversion: "优化目标",
  DeepOptimizationGoal: "深度优化",
  BidAmount: "目标出价",
  BidDailyBudget: "广告日预算",
  FirstVideoName: "首个视频名称",
  FirstImageName: "首个图片名称",
  VideoName: "视频名称",
  ImageName: "图片名称",
  CreativeFormat: "创意样式",
};

const showDataToApi = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function(node, key) {
    return "{" + (nameMap[key] || key) + "}";
  });
  return newStr;
};

const apiDatatoShow = (str) => {
  let newStr = str.replace(/{(.*?)}/g, function(node, key) {
    return "{" + (apiMap[key] || key) + "}";
  });
  return newStr;
};

export default {
  showDataToApi,
  apiDatatoShow,
};
